import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import Title from '../../../common/Title';
import ConnectionsList from './ConnectionsList';
import ConnectionsListPlaceholder from './ConnectionsListPlaceholder';

export default class ConnectionsView extends React.Component {

  get content() {
    if (!this.props.hasFetched && this.props.connections.length === 0) {
      return <ConnectionsListPlaceholder numberOfItems={3} />;
    }

    if (this.props.hasFetched && this.props.connections.length === 0) {
      return <p style={{fontSize: "16px"}}>You do not currently have any connections. When we connect you with services and staff resources, you will see them here.</p>;
    }

    return <ConnectionsList connections={this.props.connections} wrapOnMediumScreens />;
  }

  render() {
    return (
      <div>
        <Title text="Your Connections" lineHeight="24px" />
        {this.content}
      </div>
    );
  }
}

ConnectionsView.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.shape({
    personId: SFEntityID.isRequired,
    uuid: PropTypes.string,
    fullName: PropTypes.string.isRequired,
    photoAvailable: PropTypes.bool,
    roles: PropTypes.array.isRequired,
    title: PropTypes.string
  })).isRequired,
  hasFetched: PropTypes.bool.isRequired
};
